var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "g-facet-set__grid" },
    [
      _vm._l(
        _vm.facet.values.slice(0, _vm.facet.overflow.limit),
        function (value) {
          return _c(
            "label",
            { key: value.label, staticClass: "g-facet-set__grid-item" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: value.active,
                    expression: "value.active",
                  },
                ],
                staticClass: "g-form-checkbox__input",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(value.active)
                    ? _vm._i(value.active, null) > -1
                    : value.active,
                },
                on: {
                  click: function ($event) {
                    return _vm.toggleFilter(
                      _vm.facet.field,
                      value.type === "value"
                        ? value.value
                        : [value.low, value.high]
                    )
                  },
                  change: function ($event) {
                    var $$a = value.active,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && _vm.$set(value, "active", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            value,
                            "active",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(value, "active", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "g-facet-set__grid-item-name g-form-checkbox__caption",
                },
                [_vm._v("\n\t\t\t" + _vm._s(value.label) + "\n\t\t")]
              ),
            ]
          )
        }
      ),
      _vm._v(" "),
      _vm.facet.values.length > _vm.facet.overflow.limit
        ? _c("div", { staticClass: "g-facet-view-more" }, [
            _c("input", {
              staticClass: "g-facet-view-more__checkbox u-hide-visually",
              attrs: {
                id: "g-facet-view-more__" + _vm.facet.field,
                type: "checkbox",
              },
              on: { change: _vm.viewMoreChange },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "g-facet-view-more__label",
                attrs: { for: "g-facet-view-more__" + _vm.facet.field },
              },
              [_vm._v("View More")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "g-facet-view-more__content" },
              _vm._l(
                _vm.facet.values.slice(
                  _vm.facet.overflow.limit,
                  _vm.facet.values.length
                ),
                function (value) {
                  return _c(
                    "label",
                    { key: value.label, staticClass: "g-facet-set__grid-item" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: value.active,
                            expression: "value.active",
                          },
                        ],
                        staticClass: "g-form-checkbox__input",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(value.active)
                            ? _vm._i(value.active, null) > -1
                            : value.active,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.toggleFilter(
                              _vm.facet.field,
                              value.type === "value"
                                ? value.value
                                : [value.low, value.high]
                            )
                          },
                          change: function ($event) {
                            var $$a = value.active,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(value, "active", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    value,
                                    "active",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(value, "active", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "g-facet-set__grid-item-name g-form-checkbox__caption",
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(value.label) + "\n\t\t\t\t"
                          ),
                        ]
                      ),
                    ]
                  )
                }
              ),
              0
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }